import { render, staticRenderFns } from "./BestBuysIndex.vue?vue&type=template&id=27098cbd&scoped=true"
import script from "./BestBuysIndex.vue?vue&type=script&lang=js"
export * from "./BestBuysIndex.vue?vue&type=script&lang=js"
import style0 from "./BestBuysIndex.vue?vue&type=style&index=0&id=27098cbd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27098cbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27098cbd')) {
      api.createRecord('27098cbd', component.options)
    } else {
      api.reload('27098cbd', component.options)
    }
    module.hot.accept("./BestBuysIndex.vue?vue&type=template&id=27098cbd&scoped=true", function () {
      api.rerender('27098cbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/best_buys/BestBuysIndex.vue"
export default component.exports